var React = require('react');

function IconMapSettingsLayerActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","fillRule":"evenodd","d":"M20 9.003l14 7.992-14 6.924-14-6.924 14-7.992zM22 17l-3 1.607L22 20l3-1.393L22 17zm-8-2l-3 1.607L14 18l3-1.393L14 15zm8-3l-3 1.607L22 15l3-1.393L22 12zm-2 13.04l-8.35-4.124L6 24.123l14 6.874 14-6.924-5.651-3.207L20 25.039z"}));
}

IconMapSettingsLayerActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsLayerActive;

IconMapSettingsLayerActive.default = IconMapSettingsLayerActive;
